import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';
import { useEntity } from '~/hooks/use-entities';

import * as S from './AssetOverviewDrawer.styles';
import { AssetOverviewWidget } from './AssetOverviewWidget';

export interface AssetOverviewDrawerProps {
  entityTag: string;
  closeDrawer: () => void;
  isOpen: boolean;
  onClickInsight?: (insightId: string) => void;
}

export const AssetOverviewDrawer = ({
  entityTag,
  closeDrawer,
  isOpen,
  onClickInsight,
}: AssetOverviewDrawerProps) => {
  const {
    data = [],
    isLoading: entityLoading,
    isError: entityError,
  } = useEntity(entityTag);

  const entity = data[0];

  return (
    <S.StyledDrawer
      data-testid="asset-overview-drawer"
      isOpen={isOpen}
      handleCloseClick={closeDrawer}
    >
      {entityLoading ? (
        <SkeletonLoader />
      ) : entityError || !data.length ? (
        <ErrorMessageWrapper variant="empty" />
      ) : (
        <AssetOverviewWidget
          entity={entity}
          isDrawer
          onClickInsight={onClickInsight}
        />
      )}
    </S.StyledDrawer>
  );
};
